// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 290) return "static/css/290.d50e9e67.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}